import { RouteItem } from '@eastcoal/router/types/route'

import { RANKING_AUCTION_PURCHASE_LIST_PAGE_PATH } from './constants/path'

export const rankingAuctionPurchaseListRoute: RouteItem = {
  title: '竞拍（排名）',
  path: RANKING_AUCTION_PURCHASE_LIST_PAGE_PATH,
  Component: () => import('./index')
}
